import React from 'react';
import style from './index.module.scss';

interface breadCrumbInterface {
    breadCrumbs : {
        id: number,
        name: string,
        url: string
    }[];
}

const BreadCrumbs = ({ breadCrumbs }:breadCrumbInterface) => {
  const baseUrl = window.location.origin;
  let itemUrl = baseUrl;
  return (
    <>
      <div className={style.main}>
        <span className={style.linkOuter}>
          <a href={baseUrl} className={style.link}>Home</a>
        </span>
        {breadCrumbs && (
          breadCrumbs.map((item:any) => {
            itemUrl = `${itemUrl}/${item.url}`;
            return (
              <span className={style.linkOuter} key={item.id}>
                <a href={itemUrl} className={style.link}>{item.name}</a>
              </span>
            );
          })
        )}
      </div>
    </>
  );
};

export default BreadCrumbs;
